import React from 'react';
import { FadeIn } from './Shared';
import { ArrowDownRight } from 'lucide-react';
export function Mechanism() {
  return <section className="py-24 px-4 bg-[#0a0a0a] relative border-t border-neutral-900 overflow-hidden" data-id="element-83">
      {/* Background grid */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]" data-id="element-84" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-85">
        <FadeIn data-id="element-86">
          <div className="text-center mb-16" data-id="element-87">
            <div className="inline-block px-4 py-1 bg-white text-black font-bold text-sm tracking-widest uppercase mb-6" data-id="element-88">
              The Unique Mechanism
            </div>
            <h2 className="text-4xl md:text-6xl font-black uppercase mb-6" data-id="element-89">
              The "Nic-Salt <span className="text-toxic" data-id="element-90">Ladder</span>"
            </h2>
            <p className="text-xl text-neutral-400 max-w-3xl mx-auto leading-relaxed" data-id="element-91">
              A mathematical de-escalation protocol. Instead of jumping off a
              cliff, we walk down a set of stairs.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-92">
          <FadeIn delay={0.2} data-id="element-93">
            <div className="space-y-6 text-lg text-neutral-300" data-id="element-94">
              <p data-id="element-95">
                By switching to an open pod system and using a specific 21-day
                mixing ratio, we trick your brain into accepting lower doses{' '}
                <strong className="text-white" data-id="element-96">
                  without the "suffocation" panic of withdrawal.
                </strong>
              </p>
              <p data-id="element-97">
                We solve the chemical hit first, then the physical habit, then
                the social triggers.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-98">
            <div className="relative" data-id="element-99">
              {/* Ladder Visual */}
              <div className="space-y-4" data-id="element-100">
                {[{
                mg: '50mg',
                label: 'The Disposable Trap',
                color: 'bg-red-500/20 border-red-500/50 text-red-500',
                width: 'w-full'
              }, {
                mg: '35mg',
                label: 'Week 1: The Step Down',
                color: 'bg-orange-500/20 border-orange-500/50 text-orange-500',
                width: 'w-[85%]'
              }, {
                mg: '20mg',
                label: 'Week 2: The Stabilization',
                color: 'bg-yellow-500/20 border-yellow-500/50 text-yellow-500',
                width: 'w-[70%]'
              }, {
                mg: '0mg',
                label: 'Week 3: The Ghost Phase',
                color: 'bg-toxic/20 border-toxic/50 text-toxic',
                width: 'w-[55%]'
              }].map((step, i) => <div key={i} className="flex flex-col items-end" data-id="element-101">
                    <div className={`${step.width} ${step.color} border p-4 flex justify-between items-center backdrop-blur-sm`} data-id="element-102">
                      <span className="font-display font-bold" data-id="element-103">
                        {step.label}
                      </span>
                      <span className="font-black text-2xl" data-id="element-104">{step.mg}</span>
                    </div>
                    {i < 3 && <ArrowDownRight className="text-neutral-600 my-2 mr-4" size={24} data-id="element-105" />}
                  </div>)}
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}